"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentPicker = exports.CountryPicker = void 0;
var jsx_runtime_1 = require("preact/jsx-runtime");
var signals_1 = require("@preact/signals");
var select_1 = __importDefault(require("./components/select"));
var supported_documents_1 = require("./supported-documents");
var translations_1 = __importDefault(require("../common/translations"));
var CountryPicker = function (_a) {
    var country = _a.country;
    var countries = Object.entries((0, translations_1.default)("countries"));
    return (0, jsx_runtime_1.jsx)(select_1.default, { name: "country", class: "grow basis-0 relative inline-block", selected: country.value, onChange: function (value) { return country.value = value; }, options: countries.map(function (_a) {
            var code = _a[0], name = _a[1];
            return ({
                name: name,
                value: code
            });
        }) });
};
exports.CountryPicker = CountryPicker;
var FREE_TYPES = ['student-id', 'health-insurance'];
var DocumentPicker = function (_a) {
    var country = _a.country, docType = _a.docType, excludeFree = _a.excludeFree;
    var knownDocs = (0, supported_documents_1.getDocsForCountry)(country.value);
    var documentTypes = Object.entries((0, translations_1.default)("documentTypes")).filter(function (tuple) { return knownDocs.includes(tuple[0]); });
    if (excludeFree) {
        documentTypes = documentTypes.filter(function (_a) {
            var id = _a[0];
            return !FREE_TYPES.includes(id);
        });
    }
    (0, signals_1.useSignalEffect)(function () {
        var knownDocs = (0, supported_documents_1.getDocsForCountry)(country.value);
        if (!knownDocs.includes(docType.value)) {
            docType.value = knownDocs[0];
        }
    });
    return (0, jsx_runtime_1.jsx)(select_1.default, { name: "doc_type", class: "grow basis-0 relative inline-block", selected: docType.value, onChange: function (value) { return docType.value = value; }, options: documentTypes.map(function (_a) {
            var id = _a[0], name = _a[1];
            return ({
                name: name,
                value: id
            });
        }) });
};
exports.DocumentPicker = DocumentPicker;
